import React from 'react'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import Modal, {
  CloseButton,
  PrevButton
} from '@jarvis.oddle/core/components/Modal'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import Form from '@jarvis.oddle/core/components/Form'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import PoweredByOddlePass, {
  UTMSource
} from 'src/components/molecules/PoweredByOddlePass'
import IconOddlePass from '@jarvis.oddle/core/components/Icons/IconOddlePass'
import loginFlow from 'src/flows/loginFlow'
import UserContext from 'src/containers/UserContext'
import { makeControlledModal } from 'src/decorators/ModalController'
import { resetPasswordAction } from 'src/redux/user'
import useAppDispatch from 'src/hooks/useAppDispatcher'

const PasswordResetConfirmationModal = ({
  modal,
  email
}: {
  modal: {
    show: boolean
    onClose: (handler?) => void
    onClosed: () => void
  }
  email: string
}) => {
  const dispatch = useAppDispatch()
  const { t } = React.useContext(TranslationContext)
  const { isOddlePassEnabled } = React.useContext(UserContext)

  const onFormSubmit = React.useCallback(async () => {
    await dispatch(resetPasswordAction({ email }))
    loginFlow.send('passwordReset', { email })
  }, [dispatch, email])

  return (
    <Modal {...modal} slideInAnimation='top'>
      <Modal.FlexContainer>
        <Modal.Header>
          <PrevButton onClick={() => loginFlow.prev()} />
          {isOddlePassEnabled ? (
            <IconOddlePass />
          ) : (
            <H4 bold normalised>
              {t('Reset Password')}
            </H4>
          )}
          <CloseButton onClick={modal.onClose} />
        </Modal.Header>
        <Modal.Body withoutFooter>
          <Modal.Section flexGrow={1}>
            {isOddlePassEnabled && (
              <H4 normalised marginBottom={marginSizes.small} bold>
                {t(
                  'Oddle Pass reset password instructions will be sent to the following email.'
                )}
              </H4>
            )}
            <Form initialValues={{ email }} onSubmit={onFormSubmit}>
              <Form.Input disabled name='email' label={t('Email Address')} />
              <Form.SubmitButton fullWidth>
                {isOddlePassEnabled
                  ? t('Reset Oddle Pass Password')
                  : t('Reset')}
              </Form.SubmitButton>
            </Form>
            {isOddlePassEnabled && (
              <PoweredByOddlePass
                UTMSource={UTMSource.SIGNIN_MODAL}
                copyText={t(
                  'Your email is linked to _oddlePassLink_\nand can be used to log in to all restaurant partners on Oddle.'
                )}
                linkText={t('Oddle Pass')}
                linkHref='https://oddle.me/securelogin'
              />
            )}
          </Modal.Section>
        </Modal.Body>
      </Modal.FlexContainer>
    </Modal>
  )
}

export default makeControlledModal(PasswordResetConfirmationModal, 'PasswordResetConfirmationModal')
